import { HashLink } from 'react-router-hash-link';
import PMID from './PMID';
import FirstRef from '../GeneDisease/FirstRef';
import LastRef from '../GeneDisease/LastRef';
import PValue from './PValue';

function AboutAttributesVariantDisease() {
  return (
    <div id="section47">
      <h3>Variant-Disease Associations</h3>
      <ul>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/About?section=metrics#vdaScore" className="js-fix-scroll">
            DISGENET score
          </HashLink>
        </li>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/About?section=metrics#evindex" className="js-fix-scroll">
            Evidence Index
          </HashLink>
        </li>
        <PMID />
        <FirstRef />
        <LastRef />
        <li className="bullet-item">
          A representative sentence from the publication describing the association between the variant and
          the disease (if a representative sentence is not found, we provide the title of the paper){' '}
        </li>
        <li className="bullet-item">The original source reporting the Variant-Disease Association.</li>
        <li className="bullet-item">
          Ancestry: ancestry information from the original GWAS study or identified from the publication by
          text-mining. Ancestry is standardized using the{' '}
          <a href="https://github.com/EBISPOT/hancestro" target="_blank" rel="noreferrer">
            Hancestro ontology
          </a>
          .
        </li>
        <li className="bullet-item">Gender: As reported in the original GWAS study</li>
        <li className="bullet-item">
          OR: Odds ratio associated with strongest SNP risk allele. Note that if an OR {'<'} 1 is reported
          this is inverted, along with the reported allele, so that all ORs are {'>'} 1
        </li>
        <li className="bullet-item">BETA: Beta-coefficient associated with strongest SNP risk allele.</li>
        <PValue />
        <li className="bullet-item">
          GOF/LOF: indicates that the variant is gain of function (GoF) or loss of function (LoF) mutation
          associated with the phenotype
        </li>
        <li className="bullet-item">
          Polarity: indicates the polarity level of the sentence; for instance if the sentence provides supporting evidence for the association, the polarity is positive. Otherwise, if the sentence provides non-supporting evidence for the association, the polarity is negative.
        </li>
        <li className="bullet-item">
          Clinical Significance: the clinical significance for VDA evidence obtained from ClinVar.
        </li>
        {process.env.REACT_APP_RELEASE_VERSION === 'v254' && (
        <li className="bullet-item">
          ​​“Chemical Effect”: classification of the effect of a chemical on the disease, provided by processing expert-curated resources that provide adverse effect information and indications. By using the “Chemical Effect” attribute, you can select chemicals that are used for the treatment of a disease (therapeutic) or lead to a disease (toxicity). In addition, for relations reported by ClinPGX, effects include Dosage, Efficacy, Metabolism/PK, PD.
        </li>
        )}
      </ul>
    </div>
  );
}

export default AboutAttributesVariantDisease;
